import { AxiosResponse } from 'axios';

import { StatusPageLoader } from 'components/statusPage/statusPageLoader';
import { Incident, RawIncident } from 'components/statusPage/types';

export class ServiceStatusLoader extends StatusPageLoader {
  public data: Incident['status'] = 'operational';

  // eslint-disable-next-line class-methods-use-this
  private _getServiceStatus(
    components: {
      id: string;
      status: RawIncident['status'];
    }[]
  ): Incident['status'] {
    const statusComponentIds = CONFIG.statusComponentsIds;

    if (!components.length) {
      return 'operational';
    }

    const filteredComponents = components.filter(({ id }) => {
      if (!statusComponentIds.length) return true;
      return statusComponentIds.includes(id);
    });

    let serviceStatus: Incident['status'] = 'operational';
    if (filteredComponents.some(({ status }) => status === 'major_outage')) {
      serviceStatus = 'major_outage';
    } else if (
      filteredComponents.some(({ status }) => status === 'partial_outage')
    ) {
      serviceStatus = 'partial_outage';
    } else if (
      filteredComponents.some(({ status }) => status === 'degraded_performance')
    ) {
      serviceStatus = 'degraded_performance';
    } else if (
      filteredComponents.some(({ status }) => status === 'under_maintenance')
    ) {
      serviceStatus = 'under_maintenance';
    }

    return serviceStatus;
  }

  protected parseResponseData(response: AxiosResponse): Incident['status'] {
    return this._getServiceStatus(response.data.components);
  }
}
